export const MAX_OPTIONS_LIST_HEIGHT = 256;
